import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '@/components/Modal'
import { BaseView } from '@/components/base'
import { PaymentMethodItem } from '@/components/PaymentMethodItem'
import type { PaymentMethodsType } from '@/constants/paymentMethods'
import useOffsets from '@/hooks/useOffsets'

interface SelectPaymentMethodModalProps {
  isOpen: boolean
  onClose: () => void
  paymentMethods: PaymentMethodsType[]
  onSelect: (paymentMethod: PaymentMethodsType) => void
  hasEnoughBalanceToSendByWallet?: boolean
}

export const SelectPaymentMethodModal: React.FC<
  SelectPaymentMethodModalProps
> = ({
  isOpen,
  onClose,
  paymentMethods,
  onSelect,
  hasEnoughBalanceToSendByWallet = true,
}) => {
  const { t } = useTranslation()
  const offsets = useOffsets()

  const handleSelect = (paymentMethod: PaymentMethodsType) => {
    onSelect(paymentMethod)
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t(
        'translation:confirmAddMoney.selectPaymentMethod',
        'Select Payment Method',
      )}
      showHandle={true}
    >
      <BaseView
        style={{
          gap: 8,
          paddingBottom: offsets.bottom - 16,
        }}
      >
        {paymentMethods.map((paymentMethod) => {
          let isDisabled = false

          // Disable wallet if not enough balance
          if (
            paymentMethod.paymentMethod === 'Wallet' &&
            !hasEnoughBalanceToSendByWallet
          ) {
            isDisabled = true
          }

          return (
            <PaymentMethodItem
              key={paymentMethod.id}
              isDisabled={isDisabled}
              _shouldDisplayCurrencyIcon
              {...paymentMethod}
              onPress={() => handleSelect(paymentMethod)}
            />
          )
        })}
      </BaseView>
    </Modal>
  )
}

export default SelectPaymentMethodModal
